module.exports = __webpack_public_path__ + "img/electroless-nickel.85b30787.webp";